import script from "./Live.vue?vue&type=script&setup=true&lang=js"
export * from "./Live.vue?vue&type=script&setup=true&lang=js"

import "./Live.vue?vue&type=style&index=0&id=c86b77bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c86b77bc"]])

export default __exports__